export default __webpack_public_path__ + "static/media/image-ph-health-home-m@2x.673c0241.webp";